$(document).ready(function() {
  const bicDictionary  = $('#bicLabel').data('label');
  const ibanDictionary = $('#ibanLabel').data('label');
  const sepaCountries = $('#ibanLabel').data('sepa-countries');
  const scaProxyEnabled = $('#bicLabel').data('sca-proxy-enabled');

  if (!bicDictionary) { return; }

  function updateLabels() {
    const country = $('#bank_account_country').val();
    const isSepa = sepaCountries.includes(country);
    const showCaFields = country === 'CA' && !scaProxyEnabled;

    $('#caBankAccount').toggleClass('d-none', !showCaFields);
    if (!showCaFields) {
      $('#bank_account_institution_number, #bank_account_bank_name').val('');
    }

    let bicWording;
    let ibanWording;

    if (isSepa) {
      bicWording = bicDictionary['sepa'];
      ibanWording = ibanDictionary['sepa'];
    } else {
      bicWording = scaProxyEnabled ? bicDictionary['other'] : (bicDictionary[country] || bicDictionary['other']);
      ibanWording = ibanDictionary[country] || ibanDictionary['other'];
    }

    $('#bicLabel').text(bicWording + ' *');
    $('#ibanLabel').text(ibanWording + ' *');
  }

  updateLabels();

  $('#bank_account_country').on('change', updateLabels);
})
